import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { m, useScroll, useSpring } from 'framer-motion'

import { useTheme } from '@mui/material/styles'
import { Box } from '@mui/material'
// sections
import {
  HomeHero,
  HomeSupplyChain,
  HomeConfidence,
  HomeHaulwithUs,
  HomeShippingLines,
  HomeContainerTracking,
  HomePricingPlans,
  HomeServicesCarosel,
} from '../sections/home'

// ----------------------------------------------------------------------

export default function HomePage() {
  const theme = useTheme()

  const { scrollYProgress } = useScroll()

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  })

  const progress = (
    <m.div
      style={{
        top: 0,
        left: 0,
        right: 0,
        height: 1,
        zIndex: 1999,
        position: 'fixed',
        transformOrigin: '0%',
        backgroundColor: theme.palette.primary.main,
        scaleX,
      }}
    />
  )

  useEffect(() => {
    localStorage.removeItem('settings')
  }, [])

  return (
    <>
      <Helmet>
        <title> Cubistics </title>
      </Helmet>

      {progress}

      <HomeHero />

      <Box
        sx={{
          overflow: 'hidden',
          position: 'relative',
          bgcolor: 'background.default',
        }}
      >
        <HomeShippingLines />
        <HomePricingPlans />
        <HomeContainerTracking />
        <HomeSupplyChain />
        <HomeServicesCarosel />
        <HomeConfidence />
        <HomeHaulwithUs />
      </Box>
    </>
  )
}
